// extracted by mini-css-extract-plugin
export var advancedWrap = "CatalogSearch-module--advancedWrap--d95aa";
export var catalogsearch = "CatalogSearch-module--catalogsearch--09d5d";
export var contained = "CatalogSearch-module--contained--86d71";
export var content = "CatalogSearch-module--content--2c31c";
export var errorMessage = "CatalogSearch-module--errorMessage--d42b3";
export var formWrap = "CatalogSearch-module--formWrap--ce888";
export var mainFormSection = "CatalogSearch-module--mainFormSection--31391";
export var searchWrapper = "CatalogSearch-module--searchWrapper--97f16";
export var subhead = "CatalogSearch-module--subhead--b2d20";